import { Axioms as Service } from '@/services/Axioms';
import axiomsApiDomain from "@/helpers/AxiomsApiDomain";

const state = {
    userinfo: null,
    users_item: null,
    user_options: null,
    users: null,
    users_error: null,
    'mfa/devices/totp/users_item': null,
    'mfa/devices/totp/users_error': null,
    'mfa/devices/hotp/users_item': null,
    'mfa/devices/hotp/users_error': null,
    'mfa/devices/static/users_item': null,
    'mfa/devices/static/users_error': null
};
const getters = {
    active_tenant: (state) => (org) => {
        try {
            let roles_uri = `https://${axiomsApiDomain()}/claims/orgs`;
            return state.userinfo && org && org !== "false" ? state.userinfo[roles_uri].find(o => o._uuid === org) : { uuid: '', name: '' };
        } catch (error) {
            return '';
        }
    },
};

const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    }
};

const actions = {
    async getUserInfo(context) {
        let response;
        try {
            response = await Service.get_userinfo();
        } catch (error) {
            console.error(error.response.data)
            context.commit('mutate', {
                property: `userinfo_error`,
                with: response
            });
            throw error;
        }
        context.commit('mutate', {
            property: `userinfo`,
            with: response
        });
        return response;
    },

    async createItem(context, { endpoint, data, params = {} }) {
        let response;
        try {
            response = await Service.create_item(endpoint, data, params);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async getOptions(context, { endpoint }) {
        let response;
        try {
            response = await Service.get_options(endpoint);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_options`,
            with: response
        });
        return response;
    },

    async getItem(context, { endpoint, uuid, params = {} }) {
        let response;
        try {
            response = await Service.get_item(endpoint, uuid, params);
        } catch (error) {
            console.error(error.response.data)
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async getItems(context, { endpoint, params = {} }) {
        let response;
        try {
            response = await Service.get_items(endpoint, params);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}`,
            with: response.results
        });
        context.commit('mutate', {
            property: `${endpoint}_count`,
            with: response.count
        });
        context.commit('mutate', {
            property: `${endpoint}_next`,
            with: response.next
        });
        context.commit('mutate', {
            property: `${endpoint}_previous`,
            with: response.next
        });
        return response;
    },

    async patchItem(context, { endpoint, uuid, data, params = {} }) {
        let response;
        try {
            response = await Service.patch_item(endpoint, uuid, data, params);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async updateItem(context, { endpoint, uuid, data, params = {} }) {
        let response;
        try {
            response = await Service.update_item(endpoint, uuid, data, params);
        } catch (error) {
            console.error(error.response.data)
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async deleteItem(context, { endpoint, uuid }) {
        let response;
        try {
            response = await Service.delete_item(endpoint, uuid);
        } catch (error) {
            console.error(error.response.data)
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: error.response.data
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: null
        });
        return response;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}